import { AnyAction, CombinedState, combineReducers, configureStore, PreloadedState } from "@reduxjs/toolkit";
import bookingReducer from "../components/AppointmentBooking/bookingSlice";
import { IBookingState } from "../components/AppointmentBooking/bookingSlice.types";
import invoiceReducer, { IInvoiceSlice } from "../components/Invoices/invoiceSlice";

const clientPortalRootReducer = combineReducers({
    booking: bookingReducer,
    invoice: invoiceReducer,
});

const rootReducer = (
    state:
        | CombinedState<{
              booking: IBookingState;
              invoice: IInvoiceSlice;
          }>
        | undefined,
    action: AnyAction
) => {
    return clientPortalRootReducer(state, action);
};

export function setupClientPortalStore(preloadedState?: PreloadedState<ClientPortalState>) {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
    });
}

export type ClientPortalStore = ReturnType<typeof setupClientPortalStore>;
export type ClientPortalState = ReturnType<typeof rootReducer>;
export type ClientPortalDispatch = ClientPortalStore["dispatch"];
